// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"glossaryTerms_titleWrapper__FPGHl","title":"glossaryTerms_title__seyqN","allTerms":"glossaryTerms_allTerms__PgQRb","termItems":"glossaryTerms_termItems__vgwPo"};